<div class="steps-container">
  <div class="steps-wrapper">
    <ng-container *ngFor="let step of steps; let last = last">
      <!-- Step Card -->
      <div class="step-card" [class.featured]="step.isFeatured">
        <div class="step-header">
          <div class="step-number">{{ step.number }}</div>
          <div class="step-icon">
            <i [class]="step.icon"></i>
          </div>
        </div>
        <h3 class="step-title">{{ step.title }}</h3>
        <ul class="step-points">
          <li *ngFor="let point of step.points">
            <i class="fas fa-arrow-right"></i> {{ point }}
          </li>
        </ul>

        <!-- Special actions for App download step -->
        <div class="step-actions" *ngIf="step.hasActions">
          <button class="btn btn-dark">
            <i class="fab fa-google-play"></i>
            <div class="btn-text">
              <span>GET IT ON</span>
              <strong>Google Play</strong>
            </div>
          </button>
          <button class="btn btn-outline" disabled>
            <div class="btn-text">
              <span>App Store (Soon)</span>
            </div>
          </button>
        </div>
      </div>

      <!-- Arrow Connector -->
      <div class="step-connector" *ngIf="!last">
        <i class="fas fa-chevron-right"></i>
      </div>
    </ng-container>
  </div>
</div>
